export { OnboardingRateClassSelect } from './onboarding-rate-class-select.component';
export type {
  OnboardingRateClassIdValue,
  OnboardingRateClassOption,
} from './onboarding-rate-class-select.component';
